import React from "react";
import { Button } from "reactstrap";
import { Trans } from "react-i18next";

export const PendingButton = ({
  pending,
  disabled,
  component: Component = Button,
  children,
  icon,
  translate = true,
  ...props
}) => (
  <Component disabled={pending || disabled} {...props}>
    {!!pending && <span className="fa fa-fw fa-spin fa-spinner mr-1" />}
    {!!icon && <span className={icon} />}
    {translate ? <Trans>{children}</Trans> : children}
  </Component>
);

export default PendingButton;
